import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-8 px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-2xl mx-auto">
        <div className="text-8xl mb-6">🏇</div>
        <h1 className="text-4xl font-bold text-white mb-4">Page Not Found</h1>
        <p className="text-xl text-slate-400 mb-8">
          The page you're looking for doesn't exist in our stable.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <button
            onClick={handleGoBack}
            className="border border-cyan-500 text-cyan-400 px-6 py-3 rounded-lg hover:bg-cyan-500/10 transition-all duration-200 flex items-center justify-center space-x-2"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Go Back</span>
          </button>
          <Link
            to="/"
            className="bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-6 py-3 rounded-lg hover:from-cyan-600 hover:to-blue-600 transition-all duration-200 flex items-center justify-center space-x-2"
          >
            <Home className="w-5 h-5" />
            <span>Go Home</span>
          </Link>
        </div>

        {/* Quick Navigation */}
        <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-xl p-6">
          <h3 className="text-white font-semibold mb-4">Quick Navigation</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <button
              onClick={() => navigate('/dashboard')}
              className="p-3 bg-slate-700/50 rounded-lg hover:bg-slate-700 transition-colors text-slate-300 hover:text-white"
            >
              <div className="text-2xl mb-1">📊</div>
              <div className="text-sm">Dashboard</div>
            </button>
            <button
              onClick={() => navigate('/horses')}
              className="p-3 bg-slate-700/50 rounded-lg hover:bg-slate-700 transition-colors text-slate-300 hover:text-white"
            >
              <div className="text-2xl mb-1">🏇</div>
              <div className="text-sm">Horses</div>
            </button>
            <button
              onClick={() => navigate('/governance')}
              className="p-3 bg-slate-700/50 rounded-lg hover:bg-slate-700 transition-colors text-slate-300 hover:text-white"
            >
              <div className="text-2xl mb-1">🗳️</div>
              <div className="text-sm">Governance</div>
            </button>
            <button
              onClick={() => navigate('/treasury')}
              className="p-3 bg-slate-700/50 rounded-lg hover:bg-slate-700 transition-colors text-slate-300 hover:text-white"
            >
              <div className="text-2xl mb-1">💰</div>
              <div className="text-sm">Treasury</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
